// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f4-Pr","colBig":"styles_colBig__3IkJ7","colSmall":"styles_colSmall__3n5Fe","shopifyNameWrapper":"styles_shopifyNameWrapper__SzNQ3"};